module.exports = __webpack_public_path__ + "img/adam.2a19436f.svg";